// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var container = Curry._1(BrowserStyle.merge, {
      hd: Curry._1(BrowserStyle.style, {
            hd: BrowserStyle.display(BrowserStyle.flexBox),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.column),
              tl: {
                hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                tl: /* [] */0
              }
            }
          }),
      tl: /* [] */0
    });

var Styles = {
  container: container
};

var make = React.forwardRef(function (Props, ref_) {
      var className = Props.className;
      var children = Props.children;
      var onBlur = Props.onBlur;
      var onClick = Props.onClick;
      var onFocus = Props.onFocus;
      var onMouseEnter = Props.onMouseEnter;
      var onMouseLeave = Props.onMouseLeave;
      var onMouseOut = Props.onMouseOut;
      var partial_arg = Relude_Option.getOrElse((function (param) {
              return Relude_Globals.$great$great((function (prim) {
                            
                          }), Relude_IO.pure, param);
            }), onClick);
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(container, className),
        onClick: (function (param) {
            return Relude_Globals.$great$great(partial_arg, IOUtils.unsafeRunHandledAsync, param);
          })
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      var tmp$2 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onFocus);
      if (tmp$2 !== undefined) {
        tmp.onFocus = Caml_option.valFromOption(tmp$2);
      }
      var tmp$3 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onBlur);
      if (tmp$3 !== undefined) {
        tmp.onBlur = Caml_option.valFromOption(tmp$3);
      }
      var tmp$4 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseEnter);
      if (tmp$4 !== undefined) {
        tmp.onMouseEnter = Caml_option.valFromOption(tmp$4);
      }
      var tmp$5 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseLeave);
      if (tmp$5 !== undefined) {
        tmp.onMouseLeave = Caml_option.valFromOption(tmp$5);
      }
      var tmp$6 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseOut);
      if (tmp$6 !== undefined) {
        tmp.onMouseOut = Caml_option.valFromOption(tmp$6);
      }
      return React.createElement("div", tmp, children);
    });

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
